<template>
    <span
        ref="input"
        class="amInput"
        :contenteditable="true"
        @blur="onBlur"
    />
</template>

<script>
export default {
    name: 'tween-input-number',

    props: {
        value: {
            type: [Number, String],
            default: 0,
        },
    },

    mounted() {
        this.elem = this.$refs.input;
        this.elem.innerText = this.value;
    },

    methods: {
        async onBlur() {
            let value = this.elem.innerText;

            // strip out any non-numeric characters
            value = value.replace(/[^0-9]/g, '');
            value = Number(value);

            // default to zero if user-entered value is not a number
            if (Number.isNaN(value)) value = 0;

            this.$emit('input', value);
            await this.$nextTick();
            this.elem.innerText = value;
        },
    },
};
</script>

<style lang="scss" scoped>
.amInput {
    @extend %input-display;
    min-width: $tween-input-width;
    font-weight: 600;
    border-color: var(--app-borderColor);
}
</style>
